import React, {Component} from 'react';

/**
 * Allow declarative setting of the document title
 */
class DocumentTitle extends Component {
	componentDidMount() {
		if (this.props.title !== document.title) {
			document.title = this.props.title;
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.title !== document.title) {
			document.title = nextProps.title;
		}
	}

	render() {
		return this.props.children || null;
	}
}

export default DocumentTitle;



// WEBPACK FOOTER //
// ./src/widgets/DocumentTitle.js